
export const environment = {
  production: false,
  apiUrl: 'https://test.opuschatbot.ccf.org/api',
  tokenEndpointURL: 'https://03edc05b2fc4ebbda30179c2951f9d.15.environment.api.powerplatform.com/powervirtualagents/botsbyschema/ccf_opusChatbot/directline/token?api-version=2022-03-01-preview'
};
